import { useNavigate } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { Reveal } from "./Reveal";
import { ADVISORY_SERVICES } from "../../lib/data";
import { goEnquire } from "../../lib/scroll";

export const PremiumServices = () => {
  const navigate = useNavigate();
  return (
    <section id="premium-services" className="relative overflow-hidden bg-navy-deep py-24 md:py-32" data-testid="premium-services-section">
      <div className="pointer-events-none absolute -right-40 top-0 h-[420px] w-[420px] rounded-full bg-gold/10 blur-[150px]" />
      <div className="pointer-events-none absolute -left-40 bottom-0 h-[380px] w-[380px] rounded-full bg-orange/10 blur-[150px]" />
      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <p className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-gold" data-testid="premium-heading-overline">
              <Sparkles size={14} /> Premium &amp; Customised Services
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 font-heading text-3xl font-bold leading-tight tracking-tight text-white md:text-5xl" data-testid="premium-heading-title">
              Beyond Lending. Strategic Financial Advisory.
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-5 text-base leading-relaxed text-white/70 md:text-lg" data-testid="premium-heading-sub">
              Bespoke, high-touch advisory for promoters, corporates, and families — where capital strategy, growth, and resilience come together.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {ADVISORY_SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.slug} delay={(i % 3) * 0.08} y={30} className="h-full">
                <article
                  data-testid={`premium-card-${s.slug}`}
                  className="group flex h-full flex-col justify-between rounded-xl border border-gold/25 bg-white/[0.04] p-8 backdrop-blur-sm transition-all duration-500 hover:-translate-y-1 hover:border-gold/60 hover:bg-white/[0.07]"
                >
                  <div>
                    <span className="flex h-12 w-12 items-center justify-center rounded-lg border border-gold/40 bg-gold/10 text-gold">
                      <Icon size={22} strokeWidth={1.6} />
                    </span>
                    <h3 className="mt-6 font-heading text-xl font-semibold tracking-tight text-white">{s.title}</h3>
                    <p className="mt-3 text-sm leading-relaxed text-white/65">{s.short}</p>
                  </div>
                  <div className="mt-8 flex flex-wrap items-center gap-3">
                    <button
                      onClick={() => navigate(`/solutions/${s.slug}`)}
                      data-testid={`premium-know-more-${s.slug}`}
                      className="flex items-center gap-1.5 rounded-full border border-white/25 px-4 py-2 text-xs font-semibold text-white transition-colors duration-300 hover:border-gold hover:text-gold"
                    >
                      Know More <ArrowRight size={13} />
                    </button>
                    <button
                      onClick={() => goEnquire(navigate, s.title)}
                      data-testid={`premium-enquire-${s.slug}`}
                      className="rounded-full bg-gold px-4 py-2 text-xs font-bold text-navy-deep transition-transform duration-300 hover:scale-105"
                    >
                      Enquire Now
                    </button>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
